
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class InputTypeApprovalModel extends Model<InputTypeApprovalModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'approvalStatus', type: 'ApprovalStatus', languageString: 'inputTypeApproval.property.approvalStatus' },
		{ name: 'comment', type: 'string', languageString: 'inputTypeApproval.property.comment' }
	];
	[key: string]: any;
	
	public approvalStatus: ApprovalStatus;
	public comment: string;
    
	constructor(){
		super();
		this.approvalStatus = 0;
		this.comment = '';
		
	}
	getProperties(){
		return InputTypeApprovalModel.classProperties;
	}
}

export enum ApprovalStatus{
	Approved = 0,
	Rejected = 1
}
export namespace ApprovalStatus {
	export function getKeys(): Map<ApprovalStatus, string> {
		return new Map([[0, 'Approved'], [1, 'Rejected']]);
	}
}
